define(function (require) {
	//models
	const instrument_model = require('civicsModels/instrument_model');
	const IPSModel = require('civicsBase/ipsModel');

	//templates
	const tpl = require('../templates/t_lov_row_view.hbs');

	//utilities
	const utilities = require('../utilities/card_view_utilities');
	const instrument_utilities = require('civicsUtils/instrument_utilities');
	const view_manager = require('civicsUtils/view_manager');
	const modal_region = require('civicsUtils/modal_region');
	const loading_manager = require('civicsUtils/loading_manager');

	return Marionette.LayoutView.extend({
		appendLoaderToView: true,
		template: tpl,
		regions: {
			'card1Region': '@ui.card1Div',
			'card2Region': '@ui.card2Div',
			'card3Region': '@ui.card3Div',
			'card4Region': '@ui.card4Div',
			'additionalRecordsRegion': '@ui.additionalRecordsListRegion',
			modalRegion: {
				selector: 'body .rhythm-modals',
				regionClass: modal_region
			}
		},
		ui: {
			'card1Div': '.first-card',
			'card2Div': '.second-card',
			'card3Div': '.third-card',
			'card4Div': '.fourth-card',
			'topFlex': '.top-flex',
			'bottomFlex': '.bottom-flex',
			'additionalRecordsLink': '.additional-records-link',
			'rowWrapper': '.row-wrapper',
			'additionalRecordsDiv': '.additional-records',
			'additionalRecordsListRegion': '.additional-records-list-region',
			'toggleAdditionalRecordsLink': '.toggle-additional-records-link',
			'toggleAdditionalRecordsText': '.toggle-additional-records-text',
			'loadingAnnouncementDiv': '.loading-announcement'
		},
		events: {
			'click @ui.toggleAdditionalRecordsLink': 'toggleAdditionalRecords',
			'click @ui.rowWrapper': 'rowClicked'
		},
		//this initialize is not used by my assignments. This is common init code for the My Projects and Lookup portlets.
		//There is probably a better way to handle this.
		instrumentInitialize: function (options) {
			this.instrumentType = (this.model.get('_cdrType') ? this.model.get('_cdrType') : this.model.get('instrumentType')).toLowerCase();

			this.isPortalInstrument = this.instrumentType == 'portalinstrument';
			this.isRequiredRecord = this.instrumentType == 'requiredrecord';
			this.isPortalScenario = this.instrumentType == 'portalscenario';
			this.isSubmittedInstrument = !this.model.get('isPortalProject') && (instrument_utilities.isCDR(this.instrumentType) || this.instrumentType == 'servicerequest');

			this.instrumentPromise = $.Deferred();
			this.cardsReadyPromise = $.Deferred();

			//this is a promise that views extending this one can use to pass in promises.
			this.extendedPromise = $.Deferred();

			this.hasIncludedRecords = false;

			this.fetchInstrumentData();


			$.when(this.instrumentPromise, this.extendedPromise).done(function () {
				//the cardConfig and relatedRecords config need to be in the $.when, since the instrument fetch can impact the cardConfigAttribute we use.
				//Specifically, public vs customer views for instrument lookup.
				this.processCardConfig();
				this.cardsReadyPromise.resolve();
			}.bind(this));

			this.isAdditionalRecordsExpanded = false;
		},
		processCardConfig: function () {
			//this.isWizard will always fail if this isn't a myProjects portlet. that's ok.
			//we need this just in case it is the myprojects view.
			var instType = this.isWizard ? 'wizard' : this.instrumentType;
			this.cardConfig = utilities.getConfigsFor(instType, this.config.cardConfigAttribute, this.config.cardConfig);

			var cardJSON = utilities.buildCardJSON(this.instrumentModel.toJSON(), this.cardConfig, this.instrumentType, this.config.mappings);
			this.cardJSON = this.postProcessCardJSON(cardJSON);
		},
		onShow: function () {
			loading_manager.loading(true, this, false, 0);

			$.when(this.cardsReadyPromise).done(function () {
				//update the quantity badges by rerendering
				this.render();
				this.displayCards();
				if ((!this.noIncludedRecords && this.hasIncludedRecords) || (!this.noRelatedRecords && this.hasRelatedRecords && !this.config.useRelationshipView)) {
					this.ui.rowWrapper.addClass('has-additional');
					if ((this.hasIncludedRecords && this.config.defaultIncludedRecordsExpanded) ||
						(this.hasRelatedRecords && this.config.defaultRelatedRecordsExpanded)) {
						this.expandAdditionalRecords();
					}
				}
			}.bind(this));
		},
		onOpenDetailClicked: function () {
			if (this.cardJSON && $.isArray(this.cardJSON)) {
				$.each(this.cardJSON, function (index, card) {
					if (card.isSummary) {
						if (card.cardDetailsLink && card.cardDetailsLink.length > 0) {
							window.location.assign(card.cardDetailsLink);
							return false;
						} else {
							console.log('Summary card header button is not configured. Skipped opening details.');
						}
					}
				});
			}
		},
		//when a user clicks on the row, we want the map to center on that record.
		rowClicked: function (e) {
			//don't prevent propogation.
			if (this.config.mapEnabled && !this.disableMapClick) {
				this.triggerMethod('rowClicked', this.model);
			}
			$('.row-wrapper.active').removeClass('active');
			this.ui.rowWrapper.addClass('active');
		},
		displayCards: function () {
			//this should be implemented in the sub class
		},
		fetchInstrumentData: function () {
			if (this.instrumentType == 'portalinstrument') {

				this.instrumentModel = new IPSModel({
					addedDate: this.model.get('addedDateTime'),
					portalDescription: this.model.get('portalDescription'),
					lastModifiedDate: this.model.get('instrumentDateTime'),
					applicationName: this.model.get('instrumentName'),
					id: this.model.get('id')
				});
				this.instrumentModel.instrumentId = this.model.get('id');
				this.instrumentModel.instrumentType = this.instrumentType;

				this.instrumentPromise.resolve();

			} else if (this.instrumentType == 'portalscenario') {
				this.instrumentModel = new IPSModel({
					applicationName: this.model.get('instrumentName'),
					status: this.model.get('statusDescription'),
					addedDate: this.model.get('addedDateTime')
				});
				this.instrumentPromise.resolve();
			} else if (this.instrumentType == 'requiredrecord') {
				this.instrumentModel = new IPSModel(this.model.toJSON());
				this.instrumentPromise.resolve();
			} else {
				//Fetch the instrument
				if (this.config.storedProcedureMode && !this.config.isIncludedRecord && !this.config.isRelatedRecord ) {
					this.instrumentModel = this.model;
					if (this.determinePrimaryContact != null) {
						this.determinePrimaryContact();
					}
					this.instrumentPromise.resolve();
				} else {
					this.instrumentModel = new instrument_model();
					this.instrumentModel.isInMyProjects = true;
					this.instrumentModel.id = this.model.get('id');
					this.instrumentModel.instrumentType = this.instrumentType;
					this.instrumentModel.isPortalProject = this.model.get('isPortalProject');
					//For now, the select doesn't seem to be working RS side
					//instrumentModel.selects = selects;
					this.instrumentModel.fetch({
						success: function () {
							//this is a method that will exist only in the lookup portlet.
							//kinda messy, but we need to alter the cardConfigAttribute to be public/customer based on the results of this call.
							//this could be extracted into a more generic postInstrumentFetch event type function that any card view could hook into.
							if (this.determinePrimaryContact != null) {
								this.determinePrimaryContact();
							}

							//this should always be false except for my projects.
							if (this.isWizard) {
								//the project response doesn't include wizard name, so we map it over here.
								(this.instrumentModel.set({
									applicationName: this.model.get('instrumentName')
								}));
							}
							//make sure the appropriate Address/Parcel/X/Y are shown.
							//priority is Address -> Parcel ->X/Y
							if (this.instrumentModel.get('locationLine1') && this.instrumentModel.get('locationLine1').trim() != '') {
								//if the address lines are populated, make sure the parcel and X/Y lines are not.
								this.instrumentModel.set('locationLine3', '');
								this.instrumentModel.set('locationLine4', '');
								this.instrumentModel.set('locationLine5', '');
							} else if (this.instrumentModel.get('locationLine3') && this.instrumentModel.get('locationLine3').trim() != '') {
								//if the parcel line is populated, make sure the address and X/Y lines are not.
								this.instrumentModel.set('locationLine2', '');
								this.instrumentModel.set('locationLine4', '');
								this.instrumentModel.set('locationLine5', '');
							} else {
								//must be X/Y Coordinates. Make sure the second address line is clear.
								this.instrumentModel.set('locationLine2', '');
							}
							this.instrumentPromise.resolve();
						}.bind(this),
						error: function (model, response, options) {
							view_manager.errorToWindow(response);
						}
					});
				}



			}
		},
		postProcessCardJSON: function (json) {
			var summaryCard, feesCard, detailsCard, statusCard;
			var ret = [];
			var addGenericCard = true;

			$.each(json, function (index, card) {
				if (card.isSummary) {
					//no sort value because this card is always first.
					this.postProcessSummaryCard(card);
				} else if (card.isFees) {
					card.sortValue = this.config.feesOrder;
					addGenericCard = false;
					this.postProcessFeesCard(card);
				} else if (card.isDetails) {
					card.sortValue = this.config.detailsOrder;
					addGenericCard = false;
					this.postProcessDetailsCard(card);
				} else if (card.isStatus) {
					card.sortValue = this.config.statusOrder;
					addGenericCard = false;
					this.postProcessStatusCard(card);
				}
			}.bind(this));

			if (addGenericCard) {
				var genericCard = {
					title: '',
					cardClass: 'generic-card',
					columns: 4,
					sortValue: 2,
					data: [{
						dataType: 'string',
						value: i18n.t('CIVICS.COMMON.NO_ADDITIONAL_INFORMATION')
					}]
				};

				json.push(genericCard);
			}

			json.sort(function (x, y) {
				if (x.sortValue < y.sortValue || x.isSummary) {
					return -1;
				}
				if (x.sortValue > y.sortValue || y.isSummary) {
					return 1;
				}
				return 0;
			});

			return json;
		},
		postProcessStatusCard: function (card) {
			$.each(card.data, function (index, column) {
				//the status column is funky. we put the value into the description,
				//then put any status check information into the value.
				if (column.configAttributeName == 'status') {
					column.description = column.value;
					column.value = '';
					column.dataType = 'html';
				}
			}.bind(this));
		},
		postProcessDetailsCard: function (card) {
			//TODO stop changing the order localy. this should be handled on the server
			var descriptionColumn;
			var spliceIndex = -1;
			$.each(card.data, function (index, column) {
				if (column.configAttributeName == 'description') {
					//set the data type to preserve whitespace to strip HTML, but maintain line breaks and such
					column.dataType = 'preservewhitespace';
					column.columnWidth = 2;
					spliceIndex = index;
					descriptionColumn = column;
					if (this.isWizard) {
						column.editOptions = {
							editable: true,
							maxLength: 2000
						};
						column.attributeName = 'comments';
					} else if (this.instrumentType == 'requiredrecord') {
						column.columnWidth = 3;
					}
				}
			}.bind(this));
			if (spliceIndex >= 0) {
				card.data.splice(spliceIndex, 1);
				card.data.push(descriptionColumn);
			}

		},
		postProcessSummaryCard: function (card) {
			var text = null;
			var link = null;
			var value = null;
			var label = null;
			var priority = 'primary';
			if (this.isSubmittedInstrument) {
				text = i18n.t('CIVICS.COMMON.VIEW_DETAILS');
				link = this.config.instrumentDetailTargetPage.urlPath({
					intdetails: this.instrumentType,
					intid: this.model.get('id')
				});
				priority = 'primary';
				label = i18n.t('CIVICS.COMMON.VIEW_DETAILS_FOR') + ' ' + this.model.get('id') + ' ' + (this.model.get('portalDescription') ? this.model.get('portalDescription'): '');
			}

			card.cardDetailsLink = link;

			card.headerButton = {
				text: text,
				link: link,
				priority: priority,
				value: value,
				label: label
			};

			//summary Card data is displayed with no description, just the value. If a column in the card has no value,
			//it will still take up a lines worth of height. so we remove blank data in this card.
			var indexesToRemove = [];
			$.each(card.card.data, function (index, column) {
				column.descriptionClass = 'hide';
				if (column.configAttributeName == 'applicationType' ||
					column.configAttributeName == 'requestType' ||
					(this.isPortalScenario && column.configAttributeName == 'applicationName')) {
					column.valueClass = 'big-text';
				} else if (this.isSubmittedInstrument && column.configAttributeName == 'applicationNumber') {
					column.dataType = 'link';
					column.link = link;
				}
				if (column.configAttributeName == 'applicationNumber') {
					column.icon = 'notes'
				}
				if (column.value == null || column.value == '' || column.value == ' ') {
					indexesToRemove.push(index);
				}

			}.bind(this));
			//reverse decrement so we don't mess up the index while deleting items from array
			for (i = indexesToRemove.length - 1; i >= 0; i--) {
				card.card.data.splice(indexesToRemove[i], 1);
			}
		},
		actionItemClicked: function (childView, action) {
			console.log('Running action', action)
			if (this[action]) {
				this[action]();
			}
		},
	});
});
